/**
 * @generated SignedSource<<c978fb39171ff895922c81d1a0f44b4a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type InsertColumnButton$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ColumnConfigWithContainer">;
  readonly " $fragmentType": "InsertColumnButton";
};
export type InsertColumnButton$key = {
  readonly " $data"?: InsertColumnButton$data;
  readonly " $fragmentSpreads": FragmentRefs<"InsertColumnButton">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "InsertColumnButton",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ColumnConfigWithContainer"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "525941fbdce7496074d4465601d4aaa8";

export default node;
